module.exports = __webpack_public_path__ + "img/youtube.8ac937d7.svg";